import AuthTokenContainer from './container/AuthTokenContainer';

export default AuthTokenContainer;
